import loadFirebase, { getFirebaseApp } from '../firebase';

const functions = async () => {
    await loadFirebase();
    await import('firebase/compat/functions');

    const functions = getFirebaseApp().functions();
    try {
        // only connect to local firebase emulator if FB_EMULATOR is set to true
        if (process.env.FB_EMULATOR === 'true') {
            functions.useEmulator('localhost', 5001);
        }
    } catch (error) {}

    return functions;
};

export default functions;
